/*
|--------------------------------------------------------------------------
| Views: Tabbed
|--------------------------------------------------------------------------
*/

/**
 * Tabbed View
 * @namespace
 */
__gh__webApp.views.tabbed = {

	"callbacks": function(bucket){
		var utilities		= __gh__webApp.utilities;
		utilities.fetch.html.loadAllHTML();
		utilities.tabs.init();
	}
};
